
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tylenolautism/contact-us",
      function () {
        return require("private-next-pages/tylenolautism/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tylenolautism/contact-us"])
      });
    }
  